import api from "./api";

const courseService = {
  // Courses
  getCourses: (params) => api.get("/course/all", { params }),

  getCourseById: (id) => api.get(`/courses/${id}`),

  createCourse: (courseData) => api.post("/courses", courseData),

  updateCourse: (id, courseData) => api.put(`/courses/${id}`, courseData),

  deleteCourse: (id) => api.delete(`/courses/${id}`),

  getCoursesByDepartment: (departmentId) => {
    const dep = String(departmentId ?? "").trim();
    if (!dep || dep.toLowerCase() === "all") {
      return courseService.getCourseNames();
    }
    return api.get(`/assignment/courses-names`, { params: { id: dep } });
  },

  // Use institute endpoints for course import
  importCourses: (fileData) =>
    api.post("/institute/import-courses-csv", fileData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  exportCourses: (params) =>
    api.post("/export/courses-csv", params, {
      responseType: "blob",
    }),

  // Subjects
  getSubjects: (params) => api.get("/subjects", { params }),
  getAllSubjects: (params) => api.get("/subjects/all", { params }),

  getSubjectById: (id) => api.get(`/subjects/${id}`),

  createSubject: (subjectData) => api.post("/subjects", subjectData),

  updateSubject: (id, subjectData) => api.put(`/subjects/${id}`, subjectData),

  deleteSubject: (id) => api.delete(`/subjects/${id}`),

  getSubjectsByCourse: (courseId) => api.get(`/subjects/course/${courseId}`),

  getSubjectsByTeacher: (teacherId) =>
    api.get(`/subjects/teacher/${teacherId}`),

  assignTeacherToSubject: (subjectId, teacherId) =>
    api.post(`/subjects/${subjectId}/assign-teacher`, { teacherId }),

  // Subjects import endpoint lives under institute routes
  importSubjects: (fileData) =>
    api.post("/institute/import-subjects-csv", fileData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  exportSubjects: (params) =>
    api.get("/subjects/export", {
      params,
      responseType: "blob",
    }),

  // Classes
  getClasses: (params) => api.get("/class/get-all-classes", { params }),

  getClassById: (id) => api.get(`/class/get-all-classes`, { params: { id } }),

  createClass: (classData) => api.post("/classes", classData),

  updateClass: (id, classData) => api.put(`/classes/${id}`, classData),

  deleteClass: (id) => api.delete(`/classes/${id}`),

  assignClassTeacher: (classId, teacherId) =>
    api.post(`/classes/${classId}/assign-teacher`, { teacherId }),

  // Get classes for a course
  getCourseClasses: (params = {}) =>
    api.get("/course/course-classes", { params }),

  // Get class names
  getClassNames: () => api.get("/class/get-classes-names"),

  // Get subject names
  getSubjectNames: () => api.get("/subjects/get-subjects-names"),
  
  // Get course names and IDs
  getCourseNames: async () => {
    console.log('Fetching course names...');
    try {
      const response = await api.get("/course/course-names");
      console.log('Course names response:', response);
      return response.data; // Return response.data directly
    } catch (error) {
      console.error('Error in getCourseNames:', error);
      throw error;
    }
  },

  getCourseDetailsById: (id) => api.get("/course/course-details", { params: { id } }),
};

export default courseService;
